import { useContext } from "react"
import { AppContext } from "../../../contextApi/ContextApi";


export default function FormButton({disabled, type, text, action}) {
  const {primary_color, accent_color} = useContext(AppContext);
  return (
    <button type={type} disabled={disabled} style={{backgroundColor:primary_color, color:accent_color}} className='formButton' onClick={action}>{disabled ? "טוען..." : text}</button>
  )
}
